export default function (color, opacity = 0.1) {
  const number = Number.parseInt(
    _.trimStart(this.$vuetify.theme.themes.light[color], '#'),
    16
  );

  const red = number >> 16;
  const green = (number >> 8) & 255;
  const blue = number & 255;

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};
